import { useState } from 'react';
import TextFieldEditor from './TextFieldEditor';
import TextViewer from './TextViewer';
import useFieldImages from './useFieldImages';
import useFieldExternalFiles from './useFieldExternalFiles';
import TextFieldFiles from './TextFieldFiles';

const TextField = () => {
  const [editorOpen, setEditorOpen] = useState(false);

  const images = useFieldImages();
  const externalFiles = useFieldExternalFiles();

  return (
    <section>
      {editorOpen ? (
        <TextFieldEditor onClose={() => setEditorOpen(false)} />
      ) : (
        <TextViewer onOpenEditor={() => setEditorOpen(true)} />
      )}
      {(editorOpen || images.length > 0 || externalFiles.length > 0) && (
        <TextFieldFiles />
      )}
    </section>
  );
};

export default TextField;
